<template>
  <div class="my_opus">
    <div class="my_opus_box">
      <template v-if="opus_list.length">
        <opus_item v-for="(item, index) in opus_list" :opus_obj="item" :my_opus="true" :key="index"></opus_item>
      </template>
      <div class="no_List" v-else></div>
     
      
    </div>
     <div>
        <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      </div>
  </div>
</template>

<script>
import opus_item from "@/components/list_item/finaly_disign_item.vue";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    opus_item,
    myPage
  },
  data() {
    return {
      opus_list: [], //作品列表
      layerpageinfo: {
        pageSize: 6,
        pageNo: 0,
        total: 0
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    }
  },
  created() {
    if (this.designer) {
      this.getOpuses();
    } else {
      this.needInfo("getOpuses");
    }
  },
  methods: {
    needInfo(fn) {
      let watchAch = this.$watch("designer", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getOpuses();
    },
    // 获取设计师毕设作品
    getOpuses() {
      let params = Object.assign({},this.layerpageinfo,{
        user_id: this.designer.user,
        is_graduation: true
      })
      this.api.getOpuses(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.opus_list = res.obj.list || [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my_opus {
  width: 862px;
  .my_opus_box {
    width: 862px;
    display: flex;
    flex-wrap: wrap;
    .opus_item {
      margin-right: 20px;
    }
    .opus_item:nth-child(3n) {
      margin-right: 0;
    }
  }
  .no_List {
    background: url("~@/assets/img/common/no_content.png") no-repeat 100%;
    display: inline-block;
    width: 220px;
    height: 220px;
    margin: 0 auto;
    padding-top: 200px;
  }
}
</style>